<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    orderCode: String,
    type: { type: String, default: 'radio' }
  },
  data() {
    return {
      usePage: true,
      loading: false,
      tableData: []
    }
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.page.pageSize = 1000 //设置查询最大条数为1000
      this.loading = true
      this.$api
        .orderBatchListApi({
          orderCode: this.orderCode,
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    }
  }
}
</script>
